import { createStorefrontApiClient } from '@shopify/storefront-api-client';

// Used for My Page
console.log('Shopify config:', {
  storeDomain: process.env.REACT_APP_SHOPIFY_NAME,
  apiVersion: '2025-04',
  publicAccessToken: process.env.REACT_APP_HEADLESS_ACCESS_TOKEN
    ? 'SET'
    : 'NOT SET',
});

const headlessClient = createStorefrontApiClient({
  storeDomain: process.env.REACT_APP_SHOPIFY_NAME,
  apiVersion: '2025-04',
  publicAccessToken: process.env.REACT_APP_HEADLESS_ACCESS_TOKEN,
});

// Used for Merch designer
const customAppClient = createStorefrontApiClient({
  storeDomain: process.env.REACT_APP_SHOPIFY_NAME,
  apiVersion: '2025-04',
  publicAccessToken: process.env.REACT_APP_CUSTOM_APP_ACCESS_TOKEN,
});

export const getEnabledProducts = async colTitle => {
  // Only use real Shopify products - no local fallback
  try {
    // console.log('=== SHOPIFY QUERY DEBUG ===');
    // console.log('Querying collection with handle:', colTitle);
    // console.log('Handle type:', typeof colTitle);

    // // First, let's see what collections exist
    // const allCollectionsQuery = `
    //   query getAllCollections {
    //     collections(first: 20) {
    //       edges {
    //         node {
    //           id
    //           title
    //           handle
    //           products(first: 1) {
    //             edges {
    //               node {
    //                 id
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    // `;

    // try {
    //   const allCollectionsResponse =
    //     await headlessClient.request(allCollectionsQuery);
    //   console.log('Collections response:', allCollectionsResponse);
    //   const { data } = allCollectionsResponse;
    //   if (data && data.collections && data.collections.edges) {
    //     console.log('All available collections:');
    //     data.collections.edges.forEach(edge => {
    //       const productCount = edge.node.products.edges.length > 0 ? '1+' : '0';
    //       console.log(
    //         `- Handle: "${edge.node.handle}", Title: "${edge.node.title}", Products: ${productCount}`
    //       );
    //     });
    //   } else {
    //     console.log('No collections data found');
    //   }
    // } catch (err) {
    //   console.error('Failed to fetch all collections:', err);
    // }

    const query = `
      query getProductsInCollection($handle: String!) {
        collectionByHandle(handle: $handle) {
          id
          title
          handle
          products(first: 10) {
            pageInfo {
              hasNextPage
              hasPreviousPage
            }
            edges {
              node {
                id
                title
                images(first: 10) {
                  pageInfo {
                    hasNextPage
                    hasPreviousPage
                  }
                  edges {
                    node {
                      src
                    }
                  }
                }
                variants(first: 10) {
                  pageInfo {
                    hasNextPage
                    hasPreviousPage
                  }
                  edges {
                    node {
                      id
                      title
                      price {
                        amount
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;
    const response = await headlessClient.request(query, {
      variables: { handle: colTitle },
    });
    console.log('Shopify response:', response);
    const { data } = response;
    const collection =
      data && data.collectionByHandle ? data.collectionByHandle : null;
    console.log(
      'Found collection:',
      collection
        ? {
            id: collection.id,
            title: collection.title,
            handle: collection.handle,
            productCount: collection.products.edges.length,
          }
        : 'null'
    );

    const rawProducts = collection ? collection.products : { edges: [] };

    // Transform GraphQL edges/node structure to flat array
    const products = rawProducts.edges
      ? rawProducts.edges.map(edge => ({
          ...edge.node,
          images: edge.node.images.edges.map(imgEdge => ({
            src: imgEdge.node.src,
          })),
          variants: edge.node.variants.edges.map(variantEdge => ({
            ...variantEdge.node,
            // Always use the real Shopify variant ID - no fallback generation
            id: variantEdge.node.id,
          })),
        }))
      : [];

    console.log('=== END SHOPIFY QUERY DEBUG ===');
    return products;
  } catch (error) {
    console.error('Shopify API failed:', error.message);
    return [];
  }
};

export const getAllProducts = async colTitle => {
  const query = `
    query getProductsInCollection($handle: String!) {
      collectionByHandle(handle: $handle) {
        products(first: 10) {
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          edges {
            node {
              id
              title
              images(first: 10) {
                pageInfo {
                  hasNextPage
                  hasPreviousPage
                }
                edges {
                  node {
                    src
                  }
                }
              }
              variants(first: 10) {
                pageInfo {
                  hasNextPage
                  hasPreviousPage
                }
                edges {
                  node {
                    id
                    title
                    price {
                      amount
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;
  const { data } = await customAppClient.request(query, {
    variables: { handle: colTitle },
  });
  const rawProducts =
    data && data.collectionByHandle ? data.collectionByHandle.products : [];

  // Transform GraphQL edges/node structure to flat array
  const products = rawProducts.edges
    ? rawProducts.edges.map(edge => ({
        ...edge.node,
        images: edge.node.images.edges.map(imgEdge => ({
          src: imgEdge.node.src,
        })),
        variants: edge.node.variants.edges.map(variantEdge => ({
          ...variantEdge.node,
          id:
            variantEdge.node.id || `${edge.node.id}-${variantEdge.node.title}`,
        })),
      }))
    : [];

  return products;
};

export const createCart = async () => {
  const query = `
    mutation cartCreate($input: CartInput) {
      cartCreate(input: $input) {
        cart {
          id
          checkoutUrl
          totalQuantity
          cost {
            totalAmount {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;
  try {
    console.log('Creating cart with storefront client...');
    const { data } = await headlessClient.request(query, {
      variables: { input: {} },
    });

    console.log('Cart creation response:', data);

    if (data.cartCreate.userErrors && data.cartCreate.userErrors.length > 0) {
      console.error(
        'Shopify cart creation errors:',
        data.cartCreate.userErrors
      );
      throw new Error(
        `Cart creation failed: ${data.cartCreate.userErrors.map(e => e.message).join(', ')}`
      );
    }

    if (!data.cartCreate.cart) {
      console.error('No cart returned from Shopify');
      throw new Error('Cart creation failed: No cart returned');
    }

    const cart = data.cartCreate.cart;
    console.log('Cart created successfully:', cart);

    return cart;
  } catch (error) {
    console.error('Failed to create cart:', error);
    console.error('Error details:', error.message);
    throw error;
  }
};

export const addItemsToCart = async (cartId, lines) => {
  const query = `
    mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
      cartLinesAdd(cartId: $cartId, lines: $lines) {
        cart {
          id
          checkoutUrl
          totalQuantity
          cost {
            totalAmount {
              amount
              currencyCode
            }
          }
          lines(first: 100) {
            edges {
              node {
                id
                quantity
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                    price {
                      amount
                      currencyCode
                    }
                    image {
                      src
                      url
                    }
                  }
                }
              }
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;
  const { data } = await headlessClient.request(query, {
    variables: { cartId, lines },
  });

  console.log('addItemsToCart response:', data);

  if (data.cartLinesAdd.userErrors && data.cartLinesAdd.userErrors.length > 0) {
    console.error(
      'Shopify cart lines add errors:',
      data.cartLinesAdd.userErrors
    );
    throw new Error(
      `Failed to add items to cart: ${data.cartLinesAdd.userErrors.map(e => e.message).join(', ')}`
    );
  }

  const cart = data.cartLinesAdd.cart;

  if (!cart) {
    console.error('No cart returned from addItemsToCart');
    throw new Error('Failed to add items to cart: No cart returned');
  }

  return cart;
};

export const removeItemsFromCart = async (cartId, lineIds) => {
  const query = `
    mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
      cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
        cart {
          id
          checkoutUrl
          totalQuantity
          cost {
            totalAmount {
              amount
              currencyCode
            }
          }
          lines(first: 100) {
            edges {
              node {
                id
                quantity
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                    price {
                      amount
                      currencyCode
                    }
                    image {
                      src
                      url
                    }
                  }
                }
              }
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;
  const { data } = await headlessClient.request(query, {
    variables: { cartId, lineIds },
  });

  const cart = data.cartLinesRemove.cart;

  if (!cart) {
    console.error('No cart returned from removeItemsFromCart');
    throw new Error('Failed to remove items from cart: No cart returned');
  }

  return cart;
};

export const productIdNumToUri = num => {
  return `gid://shopify/Product/${num}`;
};

export const productIdUriToNum = url => {
  const parts = url.split('/');
  return parts[parts.length - 1];
};
